import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link, useParams } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"

const GETDATABYID = "api/vidhyaman"
const EDITDATA = 'api/vidhyaman/update'

function EditVidhyaman() {

    const { id } = useParams()
    const [editabledata, Setalleditabledata] = useState([]);
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();
    document.title = "Edit Vidhyaman Chaubisi- Jain Sadhana"


    useEffect(() => {
        const getdatabyid = async () => {
            try {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data.vidhyamanchaubisi
                Setalleditabledata(data)


            } catch (error) {
                console.log(error.response.data.message)

            }
        }
        getdatabyid();
    }, [])

    const HandleEdit = async (event) => {
        Setloading(true)
        event.preventDefault();

        const data = {
            englishtitle: editabledata?.englishtitle,
            hindititle: editabledata?.hindititle,
            content: editabledata?.contenttitle
        }
        try {
            const response = await axios.patch(`${EDITDATA}/${id}`, data)
            if (response.status === 200) {
                navigate('/vidhyamanlist')
                toast.success(' Successfully Edited')
                Setloading(false)
            }

        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav MasterTitleClass="active" vidhyaman="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black text-capitalize'  >Edit vidhyaman chaubisi</p>
                                    <Link to="/vidhyamanlist" className='text-black btn button-yellow text-capitalize back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All vidhyaman chaubisi</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleEdit}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata?.englishtitle} onChange={(event) => Setalleditabledata({ ...editabledata, englishtitle: event.target.value })} className="form-control  bg-gray border border-0" placeholder="Vidhyaman Chaubisi English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata?.hindititle} onChange={(event) => Setalleditabledata({ ...editabledata, hindititle: event.target.value })} className="form-control  bg-gray border border-0" id="hindititle" name='hindititle' placeholder="Vidhyaman Chaubisi Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <textarea value={editabledata?.content} onChange={(event) => Setalleditabledata({ ...editabledata, content: event.target.value })} style={{ height: "150px" }} className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Vidhyaman Chaubisi Content"  />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/vidhyamanlist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditVidhyaman